import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentsComponent } from './payments.component';
import { CashCloseComponent } from './cash-close/cash-close.component';
import { PayBookingComponent } from './pay-booking/pay-booking.component';
import { PaymentsSummaryComponent } from './payments-summary/payments-summary.component';
import { TicketsComponent } from './invoices/tickets/tickets.component';
import { EditComponent } from './invoices/edit/edit.component';
import { CashRegisterComponent } from './cash-register/cash-register.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { ProformasComponent } from './proformas/proformas.component';
import { CreateComponent } from './invoices/create/create.component';
import { PaymentsNewComponent } from './payments-new/payments-new.component';

const routes: Routes = [
  {
    path: '',
    component: PaymentsNewComponent,
    pathMatch: 'full'
  },
  {
    path: 'cashclose',
    component: CashCloseComponent,
    pathMatch: 'full'
  },
  {
    path: 'summary',
    component: PaymentsSummaryComponent,
    pathMatch: 'full'
  },
  {
    path: 'invoices',
    component: InvoicesComponent,
    pathMatch: 'full'
  },
  {
    path: 'invoices/create',
    component: CreateComponent,
    pathMatch: 'full'
  },
  {
    path: 'proformas',
    component: ProformasComponent,
    pathMatch: 'full'
  },
  {
    path: 'invoices/edit/:id',
    component: EditComponent,
    pathMatch: 'full'
  },
  {
    path: 'invoices/tickets',
    component: TicketsComponent,
    pathMatch: 'full'
  },
  {
    path: 'invoices/tickets/:id',
    component: TicketsComponent,
    pathMatch: 'full'
  },
  {
    path: 'cash-register',
    component: CashRegisterComponent,
    pathMatch: 'full'
  },
  {
    path: ':id',
    component: PaymentsNewComponent,
    pathMatch: 'full'
  },
  {
    path: 'paybooking/:id',
    component: PayBookingComponent,
    pathMatch: 'full'
  },
  {
    path: 'paybooking/:id/:amount',
    component: PayBookingComponent,
    pathMatch: 'full'
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentsRoutingModule { }
